import React, { useEffect } from 'react'
import MaterialTable from 'material-table'
import { Chip, LinearProgress } from '@material-ui/core'
import { Strings } from '../../assets/res/en'
import promotionDataColumn from '../../dataColumns/promotionDataColumn'
import useTableIcons from '../../hooks/useTableIcons'
import usePromotions from '../../hooks/modules/promotion/usePromotions'
import { SearchBar } from '../../components/searchBox/SearchBar'
import useStyles from '../../hooks/useStyles'
import { ToolBar, ModalDialog } from '../../components/tools'
import Unauthorized from '../../components/Unauthorized'

export default function Promotions(props) {
    const { tableIcons } = useTableIcons()
    const classes = useStyles()
    const {
        promotions,
        groupsMenus,
        actions,
        detailPanel,
        isLoading,
        openDialog,
        filters,
        searchData,
        getAllPromotions,
        searchOptions,
        handleModalClose,
        handleActionClick,
        modalHeader,
        modalContent,
        modalActions,
        modalFormResetKeys,
        modalTaskRunning,
        modalFormError,
        promotionPermission
    } = usePromotions()
    const { columns, sytlingOptions } = promotionDataColumn(groupsMenus)
    useEffect(() => {
        getAllPromotions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            {
                promotionPermission.read === true ?
                    <>
                        <SearchBar options={searchOptions} />
                        <MaterialTable
                            title={Strings.COLUMN_PROMOTION_TITLE}
                            icons={tableIcons}
                            columns={columns}
                            data={promotions}
                            options={sytlingOptions}
                            isLoading={isLoading}
                            actions={actions}
                            detailPanel={detailPanel}
                            localization={{ body: { editRow: { deleteText: Strings.COLUMN_PROMOTION_DELETE_TEXT } } }}
                            components={{
                                Toolbar: props => (
                                    <div>
                                        <ToolBar {...props} onAction={handleActionClick} canCreate={promotionPermission.create ?? false} />
                                        <div className={filters.filter(item => item.value && item.value.toString().trim() !== '').length > 0 ? classes.filterContainer : ""}>
                                            {
                                                filters.filter(item => item.value && item.value.toString().trim() !== '').length > 0 &&
                                                filters.filter(item => (item.value && item.value.toString().trim() !== '') || item.isClearAll === true).map(fItem => (
                                                    fItem.isClearAll === true ?
                                                        <Chip key={fItem.name} color="secondary" label="Reset All Filters" onClick={() => fItem.clearAll(filters)} /> :
                                                        <Chip key={fItem.name} color="default" label={fItem.value} onDelete={() => fItem.remove(fItem, filters, searchData)} />))
                                            }
                                        </div>
                                    </div>
                                )
                            }}
                        />
                        <ModalDialog open={openDialog}
                            handleClose={handleModalClose}
                            modalHeader={modalHeader}
                            modalContent={modalContent}
                            modalActions={modalActions}
                            modalFormResetKeys={modalFormResetKeys}
                            modalTaskRunning={modalTaskRunning}
                            modalFormError={modalFormError} />
                    </>
                    : promotionPermission.read === false ?
                    <Unauthorized />:
                    <LinearProgress/>
            }
        </>
    )
}